import { defineStore } from 'pinia'

import type { SubscriptionCancelStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useSubscriptionCancelStore = defineStore('subscription-cancel', {
  state: (): SubscriptionCancelStore => ({
    loading: false,
    modalCancelReasons: false,
    modalTryLearnWay: false,
    modalKeepLearning: false,
    modalChangePace: false,
    modalDiscount: false,
    modalDiscountSuccess: false,
    modalCancelWarning: false,
    modalPremiumTutor: false,
    modalPauseOffer: false,
    modalCrossSellDemo: false,
    modalSuccess: false,
    modalPauseConfirmed: false,
    modalImmediate: false,
    cancelReason: null,
    cancelReasonDescription: null,
    learnWayReason: null,
    keepLearningReason: null,
    subscription: null,
    product: null,
    cancelDiscount: null,
    cancelFlow: false,
    crossSellDiscipline: null,
  }),
  actions,
  getters,
})
